export default "__VITE_ASSET__DrNi_2e2__"